import Snappy from "../../../libs/snappy/snappy";
import Handlebars from "handlebars";
import $ from "jquery";

Snappy.Component.EduDisclaimer = class EduDisclaimer extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-disclaimer';
    }

    constructor(element) {
        super(element);
    }

    render () {
        this.$content = null;
        this.setEventListeners();
    }

    setEventListeners() {
        this.$window.on('profileDisclaimer:open', this.open.bind(this));
    }

    open() {
        if (!this.$content) {
            this.prepareContent();
        }

        this.$window.trigger('modal:openModal', {
            $view: this.$content,
            $prevElement: $(document)
        });
    }

    prepareContent() {
        const templateSource = $('#edu-disclaimer-template').html();
        const templateFiunc = Handlebars.compile(templateSource);
        const htmlString = templateFiunc({});
        this.$content = $(htmlString)
    }
};



// WEBPACK FOOTER //
// ./components/edu-disclaimer/scripts/edu-disclaimer.js